export const site = {
  name: "瓜网",
  nameEn: "GUAWANG",
  slogan: "吃最新鲜的瓜，看最值得读的娱乐",
  intro:
    "瓜网是一个聚焦娱乐八卦与流行文化的资讯门户，每日整理明星动态、影视综艺、音乐现场、网红观察与时尚生活话题，用编辑视角把零散的热点整理成可快速浏览、也可深读的内容流。",
  email: "hello@guawang.com",
  tipEmail: "tips@guawang.com",
  icp: "内容由瓜网编辑部独立整理，仅供阅读参考",
};

export const mainNav = [
  { label: "首页", to: "/" },
  { label: "热瓜榜", to: "/#ranking" },
  { label: "栏目精选", to: "/#categories" },
  { label: "最新资讯", to: "/#latest" },
  { label: "关于我们", to: "/about" },
  { label: "联系我们", to: "/contact" },
];

export const footerColumns = [
  {
    title: "浏览内容",
    links: [
      { label: "今日热瓜榜", to: "/#ranking" },
      { label: "栏目精选", to: "/#categories" },
      { label: "最新资讯", to: "/#latest" },
      { label: "每周盘点", to: "/#digest" },
    ],
  },
  {
    title: "关于瓜网",
    links: [
      { label: "关于我们", to: "/about" },
      { label: "内容原则", to: "/about#principles" },
      { label: "用户口碑", to: "/about#voices" },
      { label: "常见问题", to: "/#faq" },
    ],
  },
  {
    title: "参与其中",
    links: [
      { label: "联系我们", to: "/contact" },
      { label: "提供线索", to: "/contact" },
      { label: "邮箱订阅", to: "/#subscribe" },
    ],
  },
];

export const stats = [
  { value: "每日 40+", label: "条娱乐资讯整理" },
  { value: "6 大", label: "内容栏目持续更新" },
  { value: "72 小时", label: "热榜滚动统计窗口" },
  { value: "12 万", label: "位订阅读者" },
];

export const principles = [
  {
    icon: "ri-search-eye-line",
    title: "可追溯",
    desc: "每条整理都会标注原始出处与发布时间，转述与评论明确区分，避免信息在传播中变形。",
  },
  {
    icon: "ri-shield-check-line",
    title: "可验证",
    desc: "将「已证实」与「待证实」清晰标记，不确定的表述宁可留白，也不做过度推断。",
  },
  {
    icon: "ri-heart-3-line",
    title: "不伤害",
    desc: "不传播未经证实的私人信息，不参与对当事人的人身攻击，讨论止于公开事实。",
  },
  {
    icon: "ri-book-open-line",
    title: "有增量",
    desc: "不做标题搬运，每篇内容都应额外提供背景、时间线或方法论，让读完的人有所获得。",
  },
];

export const testimonials = [
  {
    name: "小满",
    role: "长期读者 · 3 年",
    avatar:
      "https://readdy.ai/api/search-image?query=Warm%20flat%20illustrated%20portrait%20avatar%20of%20a%20young%20reader%20with%20amber%20and%20olive%20color%20blocks%2C%20minimal%20geometric%20style%2C%20cream%20background%2C%20no%20text&width=200&height=200&seq=gw-avatar-01&orientation=squarish",
    text: "最早是因为懒得自己翻热搜，后来发现瓜网的一周盘点才是重点。它会把一件事的时间线拉出来，比刷十分钟短视频清楚多了。",
  },
  {
    name: "阿舟",
    role: "影视从业者",
    avatar:
      "https://readdy.ai/api/search-image?query=Warm%20flat%20illustrated%20portrait%20avatar%20of%20a%20calm%20professional%20man%20with%20amber%20and%20rose%20color%20blocks%2C%20minimal%20geometric%20style%2C%20cream%20background%2C%20no%20text&width=200&height=200&seq=gw-avatar-02&orientation=squarish",
    text: "剪辑和票房那几篇是真的写到了行业内的事。虽然面向大众，但细节没有糊弄，看得出来编辑是做过功课的。",
  },
  {
    name: "鹿尾",
    role: "订阅读者",
    avatar:
      "https://readdy.ai/api/search-image?query=Warm%20flat%20illustrated%20portrait%20avatar%20of%20a%20cheerful%20woman%20with%20amber%20and%20olive%20color%20blocks%2C%20minimal%20geometric%20style%2C%20cream%20background%2C%20no%20text&width=200&height=200&seq=gw-avatar-03&orientation=squarish",
    text: "每周邮件推送三篇文章，正好周末看完。没有广告轰炸，也不用点进一堆跳转页面，这点很难得。",
  },
];